
import { Vue, Component, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import ShopService from '@/services/shop.service';

@Component
export default class DelVideoModal extends Vue {
  listData: any = [];

  visible = false;

  title = '选择图片';

  @lazyInject(CarService)
  carService!: CarService;

    @lazyInject(ShopService)
  shopService!: ShopService;

  selectedKeys: any = [];

  @Prop()
  headrtBList!: any;

  @Prop()
  shopId!: any;

  init() {
    this.visible = true;
    const newArr = this.headrtBList.filter(
      (item: any) => item && typeof item === 'object',
    );
    this.listData = newArr;
    console.log(newArr);
  }

  handleCancel() {
    this.visible = false;
    this.selectedKeys = [];
  }

  handleCheck(key: any) {
    const index = this.selectedKeys.indexOf(key.resource_id);
    if (index > -1) {
      // 已选中，取消
      this.selectedKeys.splice(index, 1);
    } else {
      // 未选中，加入
      this.selectedKeys.push(key.resource_id);
    }
  }

  async handleOk() {
    const params = {
      shopId: this.shopId,
      header: this.selectedKeys,
    };
    const res = await this.shopService.albumShopHeaderDelete(params);
    if (res) {
      this.$message.success('删除成功');
      this.selectedKeys = [];
      this.visible = false;
      this.$emit('upload');
    }
  }
}
